import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#222B56', // Azul marino oscuro
    },
    secondary: {
      main: '#5B668A', // Azul pizarra
    },
    background: {
      default: '#FAFBFC', // Blanco hueso
      paper: '#FFFFFF',
    },
    text: {
      primary: '#222B56',
      secondary: '#5B668A',
    },
    action: {
      active: '#F6E379', // Amarillo pálido para acentos
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

export default theme;